import { useEffect, useState } from "react";
import type { PhotoItem } from "../domain/project";
import { readAssetFile } from "../storage/asset-store";

export function useAssetUrls(projectId: string, items: PhotoItem[], variant: "preview" | "thumbnail") {
  const [urls, setUrls] = useState<Record<string, string>>({});

  useEffect(() => {
    let active = true;
    const created: string[] = [];
    Promise.all(items.map(async (item) => {
      const blob = await readAssetFile(projectId, item.assetId, variant);
      const url = URL.createObjectURL(blob);
      created.push(url);
      return [item.assetId, url] as const;
    })).then((entries) => {
      if (active) setUrls(Object.fromEntries(entries));
    }).catch(() => {
      if (active) setUrls({});
    });
    return () => {
      active = false;
      created.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [projectId, items, variant]);

  return urls;
}
